var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 125,
    viewBox: "0 0 100 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0969 49.7188C62.0331 49.106 61.7821 48.5277 61.3781 48.0625L43.3781 27.0625C43.1415 26.7123 42.8336 26.4161 42.4745 26.1933C42.1154 25.9704 41.7133 25.8259 41.2945 25.7692C40.8758 25.7125 40.4497 25.7449 40.0443 25.8643C39.6389 25.9838 39.2633 26.1875 38.9422 26.4622C38.621 26.7368 38.3614 27.0763 38.1806 27.4582C37.9997 27.8402 37.9015 28.256 37.8925 28.6785C37.8835 29.101 37.9639 29.5207 38.1284 29.91C38.2928 30.2993 38.5377 30.6494 38.8469 30.9375L55.1906 50L38.8469 69.0625C38.5377 69.3506 38.2928 69.7008 38.1284 70.0901C37.9639 70.4794 37.8835 70.899 37.8925 71.3215C37.9015 71.7441 37.9997 72.1599 38.1806 72.5419C38.3614 72.9238 38.621 73.2632 38.9422 73.5379C39.2633 73.8125 39.6389 74.0163 40.0443 74.1358C40.4497 74.2552 40.8758 74.2875 41.2945 74.2308C41.7133 74.1742 42.1154 74.0297 42.4745 73.8068C42.8336 73.5839 43.1415 73.2877 43.3781 72.9375L61.3781 51.9375C61.64 51.6344 61.8385 51.2819 61.9619 50.9009C62.0854 50.5198 62.1313 50.1179 62.0969 49.7188V49.7188Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarat);
export default __webpack_public_path__ + "static/media/carat.5d394fb1.svg";
export { ForwardRef as ReactComponent };